import config from './config'

export default {
    /*
        GET     /api/v1/gallery
    */
    getProjects: function (productSlug, categorySlug, page = 1) {
        return axios.get(config.API_URL + '/gallery', {
            params: {
                'include': 'galleryThumbnail,projectCategories,featuredProducts',
                'product': productSlug,
                'category': categorySlug,
                'page': page
            }
        });
    },
    getProject: function (projectSlug) {
        return axios.get(config.API_URL + '/gallery/' + projectSlug, {
            params: {
                'include': 'galleryImages,projectCategories,featuredProducts,shareLinks'
            }
        });
    },
}